import * as checkout from '../actions/checkout'

import { BackorderCounts } from '../models/backorder-counts';

export interface State {
    error: any | null
    summaryOrder: string | null
    creating: boolean
    deliverydates: string[],
    backordercounts: BackorderCounts
}

const initialState: State = {
    error: null,
    creating: false,
    summaryOrder: null,
    deliverydates: null,
    backordercounts: {}
}

export function reducer(
    state = initialState,
    action: checkout.Actions
) {
    switch(action.type){
        case checkout.SUBMIT:
            return {
                ...state,
                error: null,
                creating: true
            }

        case checkout.SUBMIT_SUCCESS:
            return initialState

        case checkout.SUBMIT_FAILED:
            return {
                ...state,
                error: action.payload,
                creating: false
            }

        case checkout.CLEAR_ERROR:
            return {
                ...state,
                error: null
            }

        case checkout.ORDER_SUMMARY:
          return {
              ...state,
              summaryOrder: action.payload
          }

        case checkout.GET_DELIVERY_DATES_SUCCESS:
          return {
            ...state,
            deliverydates: action.payload
          }

        case checkout.GET_DELIVERY_DATES_FAILED:
          return {
            ...state,
            error: action.payload
          }

        case checkout.CLEAR_DELIVERY_DATES:
          return {
            ...state,
            deliverydates: null
          }

        case checkout.GET_BACKORDER_COUNTS_SUCCESS:
          return {
            ...state,
            backordercounts: action.payload
          }

        case checkout.GET_BACKORDER_COUNTS_FAILED:
          return {
            ...state,
            error: action.payload
          }

        case checkout.CLEAR_BACKORDER_COUNTS:
          return {
            ...state,
            backordercounts: {}
          }

        default:
            return state
    }
}

export const isCreating = (state: State) => state.creating
export const getError = (state: State) => state.error
export const getSummaryOrderNumber = (state: State) => state.summaryOrder
export const getDeliveryDates = (state: State) => state.deliverydates
export const getBackorderCounts = (state: State) => state.backordercounts
